// extracted by mini-css-extract-plugin
export default {"wrap":"_J-z","subtitle":"aK-z","contentWrap":"bK-z","imgWrap":"cK-z","heading":"dK-z","copy":"eK-z"};